export const BookFormat = Object.freeze({
	Digital: "digital",
	Physical: "physical",
	Both: "both",
});
